import './BottomPanelModal.css';
import React from 'react';
import { CloseButton } from '../CloseButton/CloseButton';
var BottomPanelModal = function BottomPanelModal(_ref) {
  var id = _ref.id,
    rtl = _ref.rtl,
    svgIcon = _ref.svgIcon,
    title = _ref.title,
    children = _ref.children,
    className = _ref.className,
    hide = _ref.hide;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className),
    role: "dialog",
    "aria-labelledby": "title_".concat(id)
  }, /*#__PURE__*/React.createElement("div", {
    className: "bottom-panel-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bottom-panel-modal__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bottom-panel-modal__header-title-wrapper"
  }, svgIcon ? /*#__PURE__*/React.createElement("div", {
    className: "bottom-panel-modal__icon",
    dangerouslySetInnerHTML: {
      __html: svgIcon
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("h2", {
    id: "title_".concat(id),
    className: "bottom-panel-modal__title"
  }, title)), /*#__PURE__*/React.createElement(CloseButton, {
    className: "bottom-panel-modal__close-btn",
    onClick: hide
  })), /*#__PURE__*/React.createElement("div", {
    className: "bottom-panel-modal__content"
  }, children)));
};
var commonStyles = "cuur04m";
var rtlStyles = "rundous";
var ltrStyles = "l1x0lslg";
export default BottomPanelModal;